import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { GeneralContext } from '../../core/app-context/GeneralContext';
import MainContent from '../../shared/components/MainContent';

export function Orders() {
  const { setSideMenu, setIdMenuSelected } = useContext(GeneralContext);

  useEffect(() => {
    setSideMenu('reversa');
    setIdMenuSelected('orders');
  }, [setSideMenu, setIdMenuSelected]);

  return (
    <MainContent>
      <Outlet />
    </MainContent>
  );
}
